<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Commandes
        <span class="separator" />
      </h1>
    </b-col>
    <ListeCommandes />
  </div>
</template>

<script>
import ListeCommandes from "@/components/commandes/ListeCommandes.vue";

export default {
  name: "BonsCommandes",
  components: {
    ListeCommandes,
  },
};
</script>

<style lang="scss" scoped></style>
